module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/singapore/font/glyphicons-halflings-regular.ttf
// module id = n9SM
// module chunks = 0